import comp from '../components/barrel';
import listReturnState from '../js/listReturnState';

export default {
  tabsYN: 1,
  async prepare() {
    // Remove all API calls from here - they will be made when tabs are accessed
  },

  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const back = listReturnState.take('ViewUser');
    const activeTab = await comp.sideNav(this.tabs);
    const backLabel = back && back.listPage === 'ViewAdvisor' ? 'Back to advisor' : 'Back to users';
    listReturnState.prependBackToSideNav(backLabel, back);
    O.changeTab(activeTab);
  },

  async pageProgress(pageData, nextPrev) {
    // if (nextPrev) {
    //   await this.changeSideNavTab(pageData[`${nextPrev}`] || nextPrev);
    // }
    // const spanCircle = U.id(`${pageData.html_text}`).firstChild;
    // spanCircle.className = '';
    // // Set colours
    // if (pageData.complete) {
    //   spanCircle.classList.add('complete');
    //   // spanCircle.classList.remove('incomplete');
    // } else {
    //   if (pageData.commenced) {
    //     spanCircle.classList.add('incomplete');
    //   }
    // }
  },

  async changeSideNavTab(pageID) {
    // await O.changeSubTab(pageID);
    // //Cheat to page --
    // // await O.changeSubTab('ADs_Equity');
    // window.scrollTo({top: 0});
    // // Expand and collapse personal details party subsub tabs
    // if (pageID === 'ADs_PersonalDetails') {
    //   U.unhide(`${pageID}_subSubTab`);
    // } else {
    //   U.hide(`ADs_PersonalDetails_subSubTab`);
    // }
  },
};
